<div class="layout-column full-height" appBringozIdGenerator="threepl-vouchers-view">
  @if (openingVoucher()) {
    <div class="layout-column layout-align-center-center flex">
      <bz-spinner [label]="'Loading' | translate"></bz-spinner>
    </div>
  } @else if (editingVoucher(); as voucher) {
    <app-threepl-edit-train-voucher-view class="flex"
                                         [voucher]="voucher"
                                         (updateVoucher)="onUpdateVoucher($event)"
                                         (back)="onBack()">
    </app-threepl-edit-train-voucher-view>
  } @else {
    <div class="layout-column flex threepl-vouchers-list">
      <div class="layout-row layout-align-start-center filter-toolbar">
        <bz-search-input class="margin-left-10"
                         appBringozIdGenerator="threepl-vouchers-search-input"
                         [placeholder]="'Search Voucher' | translate">
        </bz-search-input>

        <!-- ui-fallback: no bz date-range picker yet -->
        <app-bringoz-date-range-picker appBringozIdGenerator="threepl-vouchers-date-range-picker"
                                       [customTemplates]="filters().customTemplates"
                                       [selectedRange]="filters().range"
                                       (onChange)="onRangeChanged($event)">
        </app-bringoz-date-range-picker>
      </div>

      <app-threepl-train-vouchers-table class="flex"
                                        [items]="vm().items"
                                        [loading]="vm().loading"
                                        (voucherSelect)="onEditVoucher($event)"
                                        (voucherComplete)="onCompleteVoucher($event)"
                                        (voucherCancel)="onCancelVoucher($event)"
                                        (voucherPrint)="onPrintVoucher($event)"
                                        (fetchNext)="onFetchNext()">
      </app-threepl-train-vouchers-table>
    </div>
  }
</div>
